import { BLOGS_A } from "./blogsA";
import { BLOGS_B } from "./blogsB";

export const BLOGS = [...BLOGS_A, ...BLOGS_B];

export const getPost = (slug) => BLOGS.find((p) => p.slug === slug);

export const getAdjacent = (slug) => {
    const idx = BLOGS.findIndex((p) => p.slug === slug);
    return {
        prev: idx > 0 ? BLOGS[idx - 1] : null,
        next: idx < BLOGS.length - 1 ? BLOGS[idx + 1] : null,
    };
};
